import React from 'react';

function LinkSection({ section }) {
  if (!section.links || section.links.length === 0) {
    return null;
  }

  return (
    <div className="animate-slide-up">
      <h2 className="text-xl font-semibold text-forest-800 mb-4">
        {section.title}
      </h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {section.links.map((link) => (
          <a
            key={link.id}
            href={link.placeholder ? '#' : link.url}
            target={link.placeholder ? '_self' : '_blank'}
            rel="noopener noreferrer"
            className={`link-card group ${link.placeholder ? 'opacity-60 cursor-not-allowed' : ''}`}
            onClick={link.placeholder ? (e) => e.preventDefault() : undefined}
          >
            <div className="flex items-start space-x-3">
              <span className="text-2xl flex-shrink-0 group-hover:scale-110 transition-transform">
                {link.icon}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-gray-900 group-hover:text-forest-700 transition-colors">
                  {link.name}
                </h3>
                {link.description && (
                  <p className="text-sm text-gray-500 mt-1">
                    {link.description}
                  </p>
                )}
                {link.placeholder && (
                  <p className="text-xs text-gray-400 mt-2 italic">
                    Coming soon
                  </p>
                )}
              </div>
              {!link.placeholder && (
                <svg 
                  className="w-4 h-4 text-gray-400 group-hover:text-sage-500 transition-colors flex-shrink-0" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                  />
                </svg>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default LinkSection;